export default __webpack_public_path__ + "static/media/009-candy cane.92920258.svg";